import React from 'react';
export function EeveeImage() {
  return <img src="https://www.pokemon.com/static-assets/content-assets/cms2/img/pokedex/full/133.png" alt="Eevee" className="w-full h-full object-contain" data-id="element-45" />;
}